import React from "react";
import {connect} from "react-redux";
import VeritasHeader from "../../shared/VeritasHeader";
import {Button, Confirm, Grid, Modal} from "semantic-ui-react";
import Breadcrumb from "../../../common/partials/Breadcrumb/Breadcrumb";
import {fetchAllServices} from "../../data-services/actions/ServicesActions";
import {
    deleteBillingGroup,
    fetchAllBillingGroups,
    fetchBillingGroupDetail,
    unmountBillingGroupDetailPage
} from "../actions/BillingGroupActions";
import {fetchAllOrganizations} from "../../data-providers/actions/DataProviderActions";
import {fetchAllCountries} from "../../country-coverage/actions/CountriesActions";
import {setBreadCrumb} from "../../breadcrumb/BreadcrumbActions";
import BillingGroupDetailInfo from "./BillingGroupDetailInfo";
import BillingGroupForm from "../../add-edit/components/BillingGroupForm";
import {
    editOneBillingGroup,
    toggleBillingGroupModal,
    updatedBillingGroupRefresh,
    validateBillingGroupForm
} from "../../add-edit/actions/AddEditBillingGroupActions";
import LastUpdated from "../../../common/partials/LastUpdated";
import Sidebar from "../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../shared/VeritasSidebarButtons";
import BillingGroupPricingForm from "./BillingGroupPricingForm";

// Pricing
import {
    submitBGPricingForm,
    closeModalBGCountryPricing,
    fetchBGPricingTables, toggleModalBGPricingScheme, deleteBGPricingWarning, deleteBGCountryPricing
} from "veritas/billing-groups/actions/BillingGroupPricingActions";

export class BillingGroupDetailPage extends React.Component {

    state = {
        deleteWarning: false,
    }

    componentDidMount() {
        const {billingGroupID} = this.props.params;
        this.props.getBillingGroupDetail(billingGroupID);
        this.props.getPricingTables(billingGroupID);

        this.props.setBreadCrumb({
            parent: { url: '/veritas', text: 'Veritas' },
            list: { url: '/veritas/billing-groups', text: 'Billing Groups' },
            service: { url: '', text: '' },
            source: { url: '', text: '' },
        })

        // If the application reloads at this point, make an API call
        // to get all the services so that for a possible navigation
        // directly to the KYC or KYB Services List page, the data is
        // loaded for rendering.
        if (this.props.all_services.length === 0) {
            this.props.getAllServices();
        }
        if (this.props.all_countries.length === 0) {
            this.props.getAllCountries();
        }
        if (this.props.all_organizations.length === 0) {
            this.props.getAllOrganizations();
        }
        if (this.props.all_billing_groups.length === 0) {
            this.props.getAllBillingGroups();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {billingGroupID} = this.props.params;
        const {billingGroupDetail} = this.props;
        if (this.props.updatedBillingGroup) {
            this.props.getBillingGroupDetail(billingGroupID);
            this.props.getPricingTables(billingGroupID);
            this.props.updatedBillingGroupRefresh();
        }
        document.title = billingGroupDetail ? `Veritas - ` + billingGroupDetail.billing_group_name : '';

        this.props.setBreadCrumb({
            parent: { url: '/veritas', text: 'Veritas' },
            list: { url: '/veritas/billing-groups', text: 'Billing Groups' },
            service: { url: `/veritas/billing-groups/${billingGroupID}`,
                text: billingGroupDetail ? billingGroupDetail.billing_group_name : '' },
            source: { url: '', text: '' },
        });
    }

    componentWillUnmount() {
        this.props.unmountBillingGroupDetail();
    }

    handleCancelDeleteForBGCountryPricingClick = () => {
        this.props.deleteBGPricingWarning();
    }

    handleConfirmBGCountryPricingDelete = () => {
        const {billingGroupDetail, countryPricingIDForDelete} = this.props;
        this.props.deleteBGPricing(billingGroupDetail.id, countryPricingIDForDelete)
    }

    deleteBillingGroupButtonClick = () => {
        this.setState({deleteWarning: true});
    }

    handleCancelBillingGroupDelete = () => {
        this.setState({deleteWarning: false});
    }

    handleConfirmBillingGroupDelete = () => {
        const {billingGroupDetail} = this.props;
        this.props.deleteCurrentBillingGroup(billingGroupDetail.id);
        this.setState({deleteWarning: false});
    }

    handleEditBillingGroupButtonClick = () => {
        const { billingGroupDetail, bgBasePrice } = this.props;
        billingGroupDetail.base_price = bgBasePrice;
        this.props.editCurrentBillingGroup(this.props.billingGroupDetail);
    }

    handleEditBillingGroupCloseModal = () => {
        this.props.toggleEditBillingGroupModal();
    }

    handleBillingGroupFormSubmit = () => {
        const { billingGroupObj } = this.props;
        this.props.validateEditBillingGroup(billingGroupObj);
    }

    // Pricing Scheme Modal
    handleCloseModalBGPricingScheme = () => {
        this.props.closeModalBGPricingScheme("");
    }
    handleSubmitBGPricingForm = () => {
        this.props.submitBGPricingForm(this.props.pricingSchemeObject);
    }

    // Country Pricing Modal
    handleCloseModalBGCountryPricing = () => {
        this.props.closeModalBGCountryPricing();
    }

    get billingGroupName() {
        const { billingGroupDetail } = this.props;

        return (
            <div className="detail-page-header">
                <h1>
                    {billingGroupDetail ? billingGroupDetail.billing_group_name : ''}
                </h1>
                <div className={"last-updated"}>
                    <label>Last Updated On:
                        <LastUpdated lastUpdated={billingGroupDetail.last_updated} />
                    </label>
                    <label>By: {billingGroupDetail?.updated_by ? billingGroupDetail.updated_by : 'No data to display'}</label>
                </div>
            </div>
        );
    }


    pageContent() {
        const { billingGroupDetail, bgBasePrice, billingGroupPricingTables, canEdit } = this.props;

        return (
            <div className={"billing-group-detail-page"}>
                <Grid relaxed={true}>
                    <Grid.Column width={12}>
                        <Breadcrumb />
                        <div style={{ padding: "20px 20px 0 20px" }}>
                            {this.billingGroupName}
                            <BillingGroupDetailInfo
                                basePrice={bgBasePrice}
                                billingGroupDetail={billingGroupDetail}
                                pricingTables={billingGroupPricingTables}
                                editButton={this.handleEditBillingGroupButtonClick}
                                deleteButton={this.deleteBillingGroupButtonClick}
                                canEdit={canEdit}
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        {/*  For Additional Details Section  */}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }

    render() {
        const { billingGroupDetail } = this.props;
        const confirmDeleteMessage = Object.keys(billingGroupDetail).length === 0
            ? ``
            : `Are you sure you want to delete ${billingGroupDetail.billing_group_name}?
            This action cannot be undone.`

        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        {Object.keys(billingGroupDetail).length === 0
                            ? null
                            : this.pageContent()
                        }
                    </Grid.Column>
                </Grid>


                {/* Billing Group Form */}
                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.toggleModal}
                >
                    <Modal.Header>
                        {"Edit Billing Group"}
                    </Modal.Header>
                    <Modal.Content>
                        <BillingGroupForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleEditBillingGroupCloseModal}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleBillingGroupFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Pricing Scheme Form */}
                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.showModalBGPricingScheme}
                >
                    <Modal.Header>
                        {"Add New Pricing Scheme to the Pricing Table"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <BillingGroupPricingForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCloseModalBGPricingScheme}
                        >
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleSubmitBGPricingForm}
                        >
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Add New Country to an existing Pricing Scheme */}
                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.showModalBGCountryPricing}
                >
                    <Modal.Header>
                        {"Add New Country to This Pricing Scheme"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <BillingGroupPricingForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCloseModalBGCountryPricing}
                        >
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleSubmitBGPricingForm}
                        >
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                {/* Edit Pricing for a country configured in the Pricing Scheme */}
                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.showModalEditBGCountryPricing}
                >
                    <Modal.Header>
                        {"Edit Country Pricing Details"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <BillingGroupPricingForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleCloseModalBGCountryPricing}
                        >
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleSubmitBGPricingForm}
                        >
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Confirm
                    open={this.state.deleteWarning}
                    content={confirmDeleteMessage}
                    onCancel={this.handleCancelBillingGroupDelete}
                    onConfirm={this.handleConfirmBillingGroupDelete}
                />

                <Confirm
                    open={this.props.deleteCountryPriceWarning}
                    header='Delete Pricing Information.'
                    content="Are you sure you want to delete this Country Level Pricing?"
                    confirmButton="Delete"
                    onCancel={this.handleCancelDeleteForBGCountryPricingClick}
                    onConfirm={this.handleConfirmBGCountryPricingDelete}
                />

            </div>

        );
    }
}

const mapStateToProps = (state) => ({
    canEdit: state.marvel.user.access.accessLevel.isDPEditor,
    all_services: state.veritas.services.all_services,
    all_providers: state.veritas.providers.all_providers,
    all_organizations: state.veritas.providers.all_organizations,
    all_countries: state.veritas.countries.all_countries,
    all_billing_groups: state.veritas.billingGroups.all_billing_groups,
    billingGroupDetail: state.veritas.billingGroups.billingGroup,
    bgBasePrice: state.veritas.billingGroups.bgBasePrice,
    billingGroupObj: state.veritas.addEdit.addEditBillingGroup.billingGroupObject,
    toggleModal: state.veritas.addEdit.addEditBillingGroup.toggleModal,
    updatedBillingGroup: state.veritas.addEdit.addEditBillingGroup.updatedBillingGroup,

    showModalBGPricingScheme: state.veritas.billingGroupsPricing.showModalBGPricingScheme,
    deleteCountryPriceWarning: state.veritas.billingGroupsPricing.deleteCountryPriceWarning,
    showModalBGCountryPricing: state.veritas.billingGroupsPricing.showModalBGCountryPricing,
    showModalEditBGCountryPricing: state.veritas.billingGroupsPricing.showModalEditBGCountryPricing,
    pricingTableObjectV2: state.veritas.billingGroupsPricing.pricingTableObjectV2,
    countryPriceObject: state.veritas.billingGroupsPricing.countryPriceObject,
    pricingSchemeObject: state.veritas.billingGroupsPricing.pricingSchemeObject,
    countryPricingIDForDelete: state.veritas.billingGroupsPricing.countryPricingIDForDelete,

    billingGroupPricingTables: state.veritas.billingGroups.billingGroupPricingTables,
});

const mapDispatchToProps = dispatch => ({
    getAllServices: () => { dispatch(fetchAllServices()) },
    getAllBillingGroups: () => {dispatch(fetchAllBillingGroups())},
    getAllOrganizations: () => { dispatch(fetchAllOrganizations()) },
    getAllCountries: () => { dispatch(fetchAllCountries()) },

    getBillingGroupDetail: (billingGroupID) => { dispatch(fetchBillingGroupDetail(billingGroupID)) },
    deleteCurrentBillingGroup: (billingGroupID) => {dispatch(deleteBillingGroup(billingGroupID))},
    editCurrentBillingGroup: (billingGroupDetail) => {dispatch(editOneBillingGroup(billingGroupDetail))},
    validateEditBillingGroup: (billingGroupObj) => {dispatch(validateBillingGroupForm(billingGroupObj))},
    toggleEditBillingGroupModal: (billingGroupObj) => {dispatch(toggleBillingGroupModal(billingGroupObj))},

    getPricingTables: (billingGroupID) => { dispatch(fetchBGPricingTables(billingGroupID))},

    updatedBillingGroupRefresh: () => {dispatch(updatedBillingGroupRefresh())},
    unmountBillingGroupDetail: () => { dispatch(unmountBillingGroupDetailPage()) },
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },

    // Pricing Scheme
    closeModalBGPricingScheme: (billingGroupID) => {dispatch(toggleModalBGPricingScheme(billingGroupID))},

    // Country Pricing
    deleteBGPricingWarning: (countryPricingID) => { dispatch(deleteBGPricingWarning(countryPricingID)) },
    deleteBGPricing: (billingGroupID, countryPricingID) => { dispatch(deleteBGCountryPricing(billingGroupID, countryPricingID)) },
    closeModalBGCountryPricing: () => {dispatch(closeModalBGCountryPricing())},
    submitBGPricingForm: (pricingSchemeObject) => {dispatch(submitBGPricingForm(pricingSchemeObject))},

});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingGroupDetailPage)
